<app-resend-contract-button
	[newContractRequested]="newContractRequested"
	[pending]="pending"
	[dealStatus]="(applicationDetails$ | async).deal.status"
	(resendRequested)="resendContract()">
</app-resend-contract-button>
